import api from './api';

// Model portfolios (2026-10-05): imaginary-money portfolios AlphaGrade trades
// by itself each night. Users watch; they never place a trade here.
const base = '/model-portfolios';

export const getAccess = () => api.get(`${base}/access`).then((r) => r.data);
export const getOptions = () => api.get(`${base}/options`).then((r) => r.data);
export const getHouse = () => api.get(`${base}/house`).then((r) => r.data);
export const getMine = () => api.get(`${base}/mine`).then((r) => r.data);
export const getPortfolio = (id) => api.get(`${base}/${id}`).then((r) => r.data);
export const createPortfolio = (name, config) =>
  api.post(base, { name, config }).then((r) => r.data);
export const endPortfolio = (id) => api.post(`${base}/${id}/end`).then((r) => r.data);
